<template>
  <nav class="liquid-tabbar" :aria-label="$t('appShell.navigation')">
    <div class="liquid-tabbar-pill" aria-hidden="true"></div>
    <button v-for="(group,index) in groups" :key="group.items[0][0]" type="button"
      :aria-current="index === active ? 'page' : null">
      <AppIcon :name="group.icon"/><span>{{group.label}}</span>
    </button>
    <svg class="liquid-tabbar-clip" aria-hidden="true" focusable="false" width="0" height="0">
      <defs><clipPath :id="clipId" clipPathUnits="userSpaceOnUse"><rect x="0" y="6" width="0" height="52" rx="26"/></clipPath></defs>
    </svg>
    <div class="liquid-tabbar-active" aria-hidden="true" :style="{clipPath:`url(#${clipId})`}">
      <div v-for="group in groups" :key="group.items[0][0]"><AppIcon :name="group.icon"/><span>{{group.label}}</span></div>
    </div>
  </nav>
</template>
<script>
import AppIcon from './AppIcon.vue';
import { createLiquidNavigation } from './liquid-glass/navigation';
let nextId = 0;
export default {
  components:{AppIcon},
  props:{groups:{type:Array,required:true},active:{type:Number,required:true},darkMode:Boolean},
  data(){return {clipId:`liquid-tabbar-${nextId++}`}},
  mounted(){this._glass = createLiquidNavigation(this.$el, {
    getActive:()=>this.active, select:index=>this.$emit('select',this.groups[index].items[0][0])
  })},
  watch:{active(){this._glass?.sync()},darkMode(){this._glass?.sync()},groups(){this.$nextTick(()=>this._glass?.sync())}},
  beforeDestroy(){this._glass?.destroy()}
};
</script>
<style>
/* Glass optics and spring motion adapted from clayharmon/webgl-liquid-glass (MIT). */
#app .liquid-tabbar{
  --glass-ink:#94a3b3;--glass-active:#3d7cc4;
  position:fixed;z-index:30;left:50%;bottom:var(--native-safe-area-bottom,env(safe-area-inset-bottom,0px));
  transform:translateX(-50%);width:calc(100% - 24px);height:64px;padding:0 8px;box-sizing:border-box;
  display:flex;align-items:center;border-radius:32px;background:rgba(255,255,255,.97);
  backdrop-filter:blur(22px) saturate(105%);-webkit-backdrop-filter:blur(22px) saturate(105%);
  box-shadow:none;border:1px solid #eef3f8;
  user-select:none;-webkit-user-select:none;touch-action:pan-y;isolation:isolate;
}
#app.dark .liquid-tabbar{--glass-ink:#b7c3d3;--glass-active:#f4f9ff;background:rgba(24,32,45,.58);box-shadow:none;border-color:#ffffff24}
#app .liquid-tabbar button,#app .liquid-tabbar-active>div{
  flex:1;min-width:0;height:52px;padding:4px 0;box-sizing:border-box;display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:4px;border:0;border-radius:26px;background:transparent;color:var(--glass-ink);font-weight:500;font-family:inherit;font-size:11px;line-height:1.2;
  white-space:nowrap;-webkit-tap-highlight-color:transparent;
}
#app .liquid-tabbar button{position:relative;z-index:2;cursor:pointer}
#app .liquid-tabbar button>svg,#app .liquid-tabbar-active>div>svg{width:22px;height:22px;flex-shrink:0}
#app .liquid-tabbar button:focus-visible{outline:2px solid var(--glass-active);outline-offset:-2px}
#app .liquid-tabbar-pill{position:absolute;left:0;top:6px;height:52px;border-radius:26px;pointer-events:none;
  background:#f4f8fc;box-shadow:none;transform-origin:center;will-change:transform}
#app.dark .liquid-tabbar-pill{background:#ffffff14}
#app .liquid-tabbar-clip{position:absolute;overflow:hidden}
#app .liquid-tabbar-active{position:absolute;inset:0;display:flex;align-items:center;padding:0 8px;pointer-events:none;z-index:3}
#app .liquid-tabbar-active>div{color:var(--glass-active);font-weight:650}
@media(max-width:999px){#app .modern-main,#app .modern-main:has(.market-container){padding-bottom:calc(108px + var(--native-safe-area-bottom,env(safe-area-inset-bottom,0px)))!important}}
@media(min-width:1000px){#app .liquid-tabbar{display:none}}
@supports not (backdrop-filter:blur(1px)){#app .liquid-tabbar{background:#fafcfe}#app.dark .liquid-tabbar{background:#18202d}}
@media(prefers-reduced-transparency:reduce){#app .liquid-tabbar{background:#fafcfe;backdrop-filter:none;-webkit-backdrop-filter:none}#app.dark .liquid-tabbar{background:#18202d}#app .liquid-tabbar-pill{backdrop-filter:none;-webkit-backdrop-filter:none}}
@media(forced-colors:active){#app .liquid-tabbar{background:Canvas;border:1px solid ButtonText}#app .liquid-tabbar-active{display:none}#app .liquid-tabbar button{color:ButtonText}#app .liquid-tabbar button[aria-current]{outline:2px solid Highlight}}
</style>
